var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6923 20.2066C21.7899 20.3042 21.8672 20.42 21.92 20.5475C21.9728 20.6749 22 20.8115 22 20.9495C22 21.0874 21.9728 21.224 21.92 21.3515C21.8672 21.4789 21.7899 21.5948 21.6923 21.6923C21.5948 21.7899 21.4789 21.8672 21.3515 21.92C21.224 21.9728 21.0874 22 20.9495 22C20.8115 22 20.6749 21.9728 20.5475 21.92C20.42 21.8672 20.3042 21.7899 20.2066 21.6923L11.5 12.9844L2.79336 21.6923C2.59635 21.8893 2.32914 22 2.05053 22C1.77191 22 1.5047 21.8893 1.30769 21.6923C1.11068 21.4953 1 21.2281 1 20.9495C1 20.6709 1.11068 20.4037 1.30769 20.2066L10.0156 11.5L1.30769 2.79336C1.11068 2.59635 1 2.32914 1 2.05053C1 1.77191 1.11068 1.5047 1.30769 1.30769C1.5047 1.11068 1.77191 1 2.05053 1C2.32914 1 2.59635 1.11068 2.79336 1.30769L11.5 10.0156L20.2066 1.30769C20.4037 1.11068 20.6709 1 20.9495 1C21.2281 1 21.4953 1.11068 21.6923 1.30769C21.8893 1.5047 22 1.77191 22 2.05053C22 2.32914 21.8893 2.59635 21.6923 2.79336L12.9844 11.5L21.6923 20.2066Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.c2f30dfaaebe9f5535b7106fd6a33a22.svg";
export { ForwardRef as ReactComponent };